/**
 *
 * CardNoteItem
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { Content, Label, NoteIconContainer } from './CardData.styles';
import { StyledItem } from './CardNoteItem.styles';

const CardNoteItem = ({ content, icon, label }) => (
  <StyledItem disablePadding type="note">
    {content && (
      <Content type="note">
        {content}
        {icon && <NoteIconContainer>{icon}</NoteIconContainer>}
      </Content>
    )}
    {label && <Label type="note">{label}</Label>}
  </StyledItem>
);

CardNoteItem.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default memo(CardNoteItem);
